export default (
  container = '.container',
  scrollableElement = '.container__scrollable',
  scrollbar = '.container__scrollbar'
) => {
  const scrollEvent = (e) => {
    [...document.querySelectorAll(container)].map((el) => {
      const scroller = el.querySelector(scrollableElement);
      const scrollBar = el.querySelector(scrollbar);

      const paginationCurrent =  el.querySelector('.js-slider-pagination').querySelector('.pagination-current');

      paginationCurrent.innerHTML = '01';

      let totalCount = scroller.childElementCount;

      if (totalCount.toString().length === 1) {
        totalCount = '0' + totalCount
      }

      el.querySelector('.js-slider-pagination').querySelector('.pagination-total').innerHTML = totalCount
      

      const isScrollbarRequired = () =>
        scroller.scrollWidth > scroller.getBoundingClientRect().width;
      const toggleScrollbar = () =>
        scrollBar.classList[!isScrollbarRequired() ? 'add' : 'remove'](
          `${scrollbar.replace('.', '')}--hidden`
        ) || isScrollbarRequired();

      const updateScrollBar = (e) => {
        if (!toggleScrollbar()) return;
        const percentage =
          (scroller.scrollLeft /
            (scroller.scrollWidth -
              scroller.getBoundingClientRect().width.toFixed())) *
          100;
        scrollBar.value = percentage.toFixed(2);

        console.log(scroller.childElementCount)

        let page = Math.ceil((scroller.childElementCount - 1) * (percentage / 100))

        if (page.toString().length === 1) {
          // Hack - pagination is flawed, needs refactoring. This is a quick hack to sort out edge detection
          if ( parseInt(page) === 0 ) { page = 1; }
          if ( parseInt(percentage) === 100 ) { page = scroller.childElementCount; }

          page = '0' + page;
        }

        paginationCurrent.innerHTML = page;
      };

      const updateScrollPosition = (e) => {
        scroller.scroll({
          top: 0,
          left:
            (e.target.value / 100) *
            (scroller.scrollWidth - scroller.getBoundingClientRect().width),
          behavior: 'auto'
        });
      };

      updateScrollBar();
      setTimeout(updateScrollBar, 1000);

      const nextBtn = el.querySelector('.swiper-button--next');
      const prevBtn = el.querySelector('.swiper-button--prev');

      const getItemWidth = () => {
        return scroller.scrollWidth / scroller.childElementCount
      }

      nextBtn.addEventListener('click', () => {
        scroller.scrollBy({
          left: getItemWidth(),
          behavior : "smooth"
        });

        updateScrollBar();
      })

      prevBtn.addEventListener('click', () => {
        scroller.scrollBy({
          left: -getItemWidth(),
          behavior : "smooth"
        });

        updateScrollBar();
      })

      scroller.addEventListener('scroll', updateScrollBar, {passive: true});
      scroller.addEventListener('DOMContentLoaded', updateScrollBar);
      document.addEventListener('vue:loaded', updateScrollBar);
      window.addEventListener('resize', updateScrollBar);

      scrollBar.addEventListener('input', updateScrollPosition);
    });
  };

  document.addEventListener('DOMContentLoaded', scrollEvent);
  document.addEventListener('vue:loaded', scrollEvent);
  scrollEvent();
};
 